export default __webpack_public_path__ + "static/media/sports (7).ca3cc3e2.jpg";